import gemsData from '../../static/gems.json';

const INITIAL_STATE = { gemsData };

const gems = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default gems;



// WEBPACK FOOTER //
// ./src/features/gems/reducers.js